module.exports = __webpack_public_path__ + "static/media/circle_answer.e0712927.jpg";